<template>
	<div>
		<p>
			The Limb Setup module is used to assign references to your character's limbs, so your character can be controlled by the game's animations correctly. For the most part, these fields 
			are pretty straightforward - just drag and drop object references from your character's rig in the Hierarchy window to the appropriate fields. This tutorial will just touch on some 
			points of interest and information about the less obvious fields.
		</p>
        
		<b-img src="/images/importer/module-limb-setup/limb-setup-anthro.jpg"></b-img>
		<p>
			<span class="font-weight-bold">Populate Fields From Avatar:</span> If you have set up a Unity Avatar for your character model (see the 
			<router-link :to="{name: 'tutorials', params: {tutorialName: 'ModelExportAndImport'}}">Model Export and Import</router-link> tutorial), this button will pull in the bones assigned 
			on your avatar to the corresponding limb fields in this module, which are mostly hidden for Anthro characters.
		</p>
        
		<p>
			<span class="font-weight-bold">Head Offset:</span> This offset determines the position of the 1st person camera in desktop mode, and the position of the player's viewpoint in VR mode.
			The guide mesh for this offset resembles a VR headset - place it over your character's eyes as if they were wearing it.
		</p>
        
		<p>
			<span class="font-weight-bold">Hand / Foot Grip Alignment:</span> This section is for setting up objects to serve as the Palm and Sole of each hand and foot, to be used by the game's
			alignment system during interactions. Start by pressing the Initialize button to create these objects in your character, and then select each one to tweak its orientation as needed. These
			objects are created at approximately the expected position and rotation but may require adjustment - see the Example scenes for reference of how they are expected to be position and
			oriented relative to each limb.
		</p>
        
		<h3 class="mt-4">Feral Characters</h3>
		<b-img src="/images/importer/module-limb-setup/limb-setup-feral.jpg"></b-img>
		<p>
			<span class="font-weight-bold">Spine / Neck:</span> For the spine, include all of the bones between the Hips and the Chest (including the Chest, but not the Hips). The Neck should include
			all bones between the chest and the head. Each item in the list also has a "Weight" field, which determines how much relative weight this bone will have in the IK chain when animating 
			the character. For best results, the lower spine/neck bones should have a higher weight (1), decreasing along the chain until the last bone has a low weight (0.1 - 0.2).
		</p>
	</div>
</template>

<script>
export default {
		name: 'LimbSetupModule',
}
</script>
